// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledToolbarSetContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isRightPositioned'
})<BoxProps & { isRightPositioned?: boolean }>(
  ({ theme, isRightPositioned }) => ({
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: isRightPositioned ? 'row-reverse' : 'column',
    gap: theme.spacing(4)
  })
);

export const StyledMainContentContainer = styled(Box)<BoxProps>(() => ({
  flex: 1,
  minWidth: 0,
  /**
   * The companion to minWidth above, on the other axis. Without it this flex item keeps the automatic
   * minimum size of a column flex item — its content's height — so it grows past the toolbar container
   * instead of taking the space that is left. Content sized against it (`height: 100%`) then has no
   * definite height to resolve against and falls back to its intrinsic height, which is how a grid
   * meant to scroll inside this box ends up rendering full height with no scrollbar at all.
   */
  minHeight: 0
}));
